import http from '../../http'

const API_URL = "absence-other-cause"

/** Ítem 3.3.6 — Ausentismo por otras causas (no médicas). */
class AbsenceOtherCauseAPI {

  async causeTypes() {
    const response = await http(`${API_URL}/cause-types`, 'GET')
    return response && response.data ? response.data : []
  }

  async employeesList(companyId) {
    const response = await http(`${API_URL}/employees_list/${companyId}`, 'GET')
    return response && response.data ? response.data : []
  }

  async getAll(companyId, page = 1) {
    const response = await http(`${API_URL}/index/${companyId}?page=${page}`, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/show/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async update(id, data) {
    return await http(`${API_URL}/update/${id}`, 'PUT', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }
}

export default new AbsenceOtherCauseAPI()
